import styled from 'styled-components';

export const Container = styled.div`
    margin-bottom: 32px;
`;

export const ContainerForm = styled.div`
    background-color: #ffffff;
    border-radius: 12px;
    border: 1px solid #f0f1f3;
    gap: 32px;
    flex-wrap: wrap;
    padding: 32px 32px 24px 32px;

    @media (max-width: 768px) {
        padding: 24px 16px 16px 16px; // padding menor em dispositivos móveis
    }
`;

export const ContainerSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const ContainerButton = styled.div`
    display: flex;
    justify-content: center;
    padding: 32px 0 0 0;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        button {
            width: 100%;
            max-width: 300px;
        }
    }
`;
